document.getElementById('trackOrderForm').addEventListener('submit', async (e) => {
  e.preventDefault();

  const customerData = document.querySelector(`.tracking-order #TrackOrder-customerData`).value.trim();
  const orderNumber = document.querySelector(`.tracking-order #TrackOrder-order`).value;
  const formSubmitBtn = document.querySelector(`.tracking-order #trackOrderForm [type="submit"]`);
  const formSubmitBtnSpinner = formSubmitBtn.querySelector(`.loading__spinner`);
  const language = document.querySelector(`.tracking-order #trackOrderForm`).dataset.language;
  const results = document.querySelector(`.tracking-order #trackingResult`)

  // Apply loading class to the Submit button
  formSubmitBtn.classList.add('loading')
  // Show the spinner
  formSubmitBtnSpinner.classList.remove('hidden')
  
  try {
    const response = await fetch('https://rastova-shopify-order-tracker.vercel.app/track-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ customerData, orderNumber, language })
    });

    const data = await response.json();
    console.log(`Data success: ${data.success}`);
    if (data.success) {
      /*
      const trackingResultsHTML = `
        <p><strong>Tracking Number:</strong> ${data.trackingNumber}</p>
        <p><strong>Courier:</strong> ${data.courier}</p>
        <p><strong>Status:</strong> ${data.status}</p>
        <p><strong>Estimated Delivery:</strong> ${data.estimatedDelivery}</p>
        <p>
        <a target="_blank" href="https://www.smsaexpress.com/tr/trackingdetails?tracknumbers%5B0%5D=${data.trackingNumber}">${data.trackingUrl}</a>
        </p>
      `
      */
      const trackingResultsHTML = `
        <p class="tracking-results__tracking-number"><strong>${data.trackingNumberText}</strong> ${data.trackingNumber}</p>
        <p class="tracking-results__tracking-url-wrapper">
           <a target="_blank" href="${data.trackingUrl}" class="tracking-results__tracking-url">${data.trackingButtonText}</a>
        </p>
      `
      results.innerHTML = trackingResultsHTML;
    } else {
      const trackingResultsHTML = `<p>${ data.message }</p>`
      results.innerHTML = trackingResultsHTML;
    }

    // Scroll to the results
    // results.scrollIntoView();

    // Remove loading class from the Submit button
    formSubmitBtn.classList.remove('loading')
    // Hide the spinner
    formSubmitBtnSpinner.classList.add('hidden')
  } catch (error) {
    console.error('Error:', error);
    results.innerHTML = `<p>Something went wrong. Please try again.</p>`;
  }
});